module.exports = __webpack_public_path__ + "static/media/slidersSVG.f823cc77.svg";